module.exports = __webpack_public_path__ + "img/10-chicken-inn.063515e9.jpg";